const GSM7REGEX =
  /^[\n\r -~€£¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ!"#¤%&'()*+,\-./0-9:;<=>?¡A-ZÄÖÑÜ§¿a-zäöñüà]*$/;

export const checkSMSLength = (text) => {
  const is_gsm_7 = GSM7REGEX.test(text);
  const length = text.length;

  let single = 70;
  let concat = 67;
  let encoding = 'USC-2';

  if (is_gsm_7) {
    single = 160;
    concat = 153;
    encoding = 'GSM-7';
  }

  const segments = length <= single ? 1 : Math.ceil(length / concat);
  return { encoding, length, segments };
};
